import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../../shared/typings/vw-theme";

export const StyledDeactivateAccountConfirmationContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 72svh;
`;

export const StyledConfirmInformationContainer: any = styled.div``;

export const StyledConfirmButtonsContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static350};

      button:first-child {
        background: ${theme.colors.signal.error};

        @media (min-width: ${Breakpoints.b1920}px) {
          order: 2;
        }
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        flex-direction: row;
        justify-content: flex-end;
      }
    `;
  }}
`;


